import React, {useState} from 'react';
import {MasterDetail} from '~/components/global/MasterDetail.client';
import {SearchspringFacetFiltersV2} from '~/components/product/searchspring/SearchspringFacetFiltersV2.client';
import InfinitescrollV2Client from '~/routes/collections/InfinitescrollV2.client';
export function CollectionPage({handle}) {
  const [searchspringData, setSearchspringData] = useState(null);
  const [sort, setSort] = useState(null);
  const onSortChange = (sortOption) => {
    setSort(sortOption);
  };
  return (
    <>
      <MasterDetail
        sortOptions={[
          {label: 'Select an option', value: null},
          {label: 'Price: Low to High', value: 'sort.ss_price=asc'},
          {label: 'Price: High to Low', value: 'sort.ss_price=desc'},
          {label: 'Name (A - Z)', value: 'sort.title=asc'},
          {label: 'Name (Z - A)', value: 'sort.title=desc'},
        ]}
        onSortChange={onSortChange}
        master={
          <SearchspringFacetFiltersV2 searchspringData={searchspringData} />
        }
        detail={
          <InfinitescrollV2Client
            handle={handle}
            searchspringData={searchspringData}
            setSearchspringData={setSearchspringData}
            resultsPerPage={12}
            sort={sort}
          />
        }
      />
    </>
  );
}
